import React, { useMemo } from 'react';

import {
    CallRecordKeysByDate,
    CallRecordRow,
    callHistoryRowKey,
    callRecordKeyDates,
    rowIsFocusable,
} from 'flow/components/call-history-v2/call-history-rows';
import DateGroupedList, {
    DateGroupedRowProps,
} from 'flow/components/call-history-v2/DateGroupedList';
import { QueueKey } from 'flow/types/EntityKeys';
import HistoryCallRecordItem from './call-record/HistoryCallRecordItem';

interface Props {
    callRecordKeysByDate: CallRecordKeysByDate;
    queueKey: QueueKey;
}

/**
 * The finished calls of a queue by date, as one Tab stop. No call's page is
 * open while the list shows, so Tab enters at the first call until a call has
 * had focus.
 */
const QueueHistoryList = ({ callRecordKeysByDate, queueKey }: Props) => {
    const dates = useMemo(
        () => callRecordKeyDates(callRecordKeysByDate),
        [callRecordKeysByDate],
    );

    // A row's own control is its link to the call.
    const renderRow = (row: CallRecordRow, rowProps: DateGroupedRowProps) => (
        <HistoryCallRecordItem
            callRecordKey={row.callRecordKey}
            queueKey={queueKey}
            {...rowProps}
        />
    );

    return (
        <DateGroupedList
            dates={dates}
            rowKey={callHistoryRowKey}
            rowIsFocusable={rowIsFocusable}
            renderRow={renderRow}
        />
    );
};

// The section around the list renders again as it loads more; the list does
// not, while its calls are the same.
export default React.memo(QueueHistoryList);
